import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import StreetAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/street-autocomplete.vue";
import PostalAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/postal-autocomplete.vue";
import { ValidationErrors } from "../../new-contract-vue";
import { mapState } from "vuex";
import { INewContractState } from "../../new-contract-vuex-store";
import { IContractViewModel, IAddressViewModel, IFinalInvoicingAddressViewModel, IMeteringPointViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import ContractPartnerCard from "./components/contract-partner-card.vue";
import { SectionChecker } from "../../Default/common/section";
import { ContactPersonUtils } from "../../../../../Scripts/inpulse/ContactPersonUtils";

class Checker extends SectionChecker {
    constructor() {
        super();
        this.idProperties = [
            //(contract: IContractViewModel) => contract.Customer.Pin,
            (contract: IContractViewModel) => contract.Customer.Phone,
            (contract: IContractViewModel) => contract.Customer.Email,
            (contract: IContractViewModel) => contract.MeteringPoint.Address.Street,
            (contract: IContractViewModel) => contract.MeteringPoint.Address.Zip,
        ];
        this.validationIds = ["Phone", "Email", "Street", "Zip", "MoveOutStreetOnline", "MoveOutZipOnline", "MoveOutEmail"];
    }
}
export const MoveOutCustomerChecker = new Checker();

@Component({
    components: {
        ValidatedFormGroup,
        ValidationMessage,
        PostalAutocomplete,
        StreetAutocomplete,
        ContractPartnerCard
    },
    computed: mapState({
        contractPartners: (state: INewContractState) => {
            let res = [];
            state.contract.Customer.ContractPartners.forEach(x => {
                if (!ContactPersonUtils.isEmpty(x))
                    res.push(x);
            });
            return res;
        },
    }),
})

export default class MoveOutCustomerSelection extends Vue {
    get moveOutName(): string { return this.$store.state.moveOutUser; }
    get contractsSelected(): boolean { return this.$store.state.contract.MoveOutProcess.ConsumptionPoints.length > 0; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get meteringPoint(): IMeteringPointViewModel { return this.$store.state.contract.MeteringPoint; }
    get finalInvoicingAddress(): IFinalInvoicingAddressViewModel { return this.$store.state.contract.MoveOutProcess.FinalInvoicingAddress; }

    get mpStreet(): string { return this.finalInvoicingAddress.Address.Street }
    get postal(): string { return this.finalInvoicingAddress.Address.Zip }
    get postOffice(): string { return this.finalInvoicingAddress.Address.Place }
    get coName(): string { return this.finalInvoicingAddress.Address.COName }

    @Prop()
    public validationErrors: ValidationErrors;

    postalStr: string;
    mpStreetStr: string;
    mpStreetLocale: string = null;
    mpZipLocale: string = null;

    constructor() {
        super();
        console.log("MoveOutCustomerSelection constructor");
        this.mpStreetStr = this.mpStreet;
        this.postalStr = this.postal;
    }
    mounted() {
        $("#mpStreetStr_autocomplete input").attr("id", "mpStreetStr_field");
        $("#mpStreetStr_autocomplete input").removeAttr("aria-controls");
        $("#postalStr_autocomplete input").attr("id", "postalStr_field");
        $("#postalStr_autocomplete input").removeAttr("aria-controls");
    }

    @Watch("mpStreet")
    keepMpSync() {
        this.mpStreetStr = this.mpStreet;
        console.log("mpStreet: " + this.mpStreet);
    }

    @Watch("postal")
    keepSync() {
        this.postalStr = this.postal;
    }

    customerPhone: string = this.$store.state.contract.Customer.Phone;

    customerPhoneChanged() {
        console.log("customerPhone: " + this.customerPhone);

    }

    meteringPointPostalSelected(postCode: string, locale: string) {
        this.postalStr = postCode;
        this.mpZipLocale = locale;
        this.$store.dispatch("changeValue", { key: "MoveOutZipOnline", value: postCode, locale: locale });
    }

    meteringPointStreetSelected(street: string, locale: string) {
        this.mpStreetStr = street;
        this.mpStreetLocale = locale;
        this.$store.dispatch("changeValue", { key: "MoveOutStreetOnline", value: street, locale: locale });
    }
}